module.exports = __webpack_public_path__ + "src/client/screens/UserSearch/InviteUserModal/illustration.svg";